@import "~/styles/variables";

.ModalClose {
  @include transition;
  align-items: center;
  background: $color-grey-light;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: $space-xl;
  justify-content: center;
  position: absolute;
  right: $space-xs;
  top: $space-xs;
  width: $space-xl;
  z-index: 1;

  &:hover {
    background: $color-grey;
  }
}
